<template>
  <button
    :class="['button', { 'button--selected': isSelected }]"
    @click="click"
    @dblclick="dblclick"
  >
    <transition name="fade" appear>
      <div v-if="isSelected" class="checkmark">
        <img
          class="checkmark__image"
          src="@/assets/img/checkmark_white.svg"
          alt="checkmark"
        />
      </div>
    </transition>

    <div v-if="isLoading" :style="computedStyle" class="skeleton" />

    <img
      ref="image"
      :src="image.urls.small"
      :alt="image.alt_description"
      :class="['image', { 'image--loading': isLoading }]"
      @load="setPicture"
    />

    <div class="user-link">
      {{ $t('PHOTO_BY') }}
      <a
        class="user-link__text"
        :href="`https://unsplash.com/@${image.user.username}?utm_source=admin&utm_medium=referral`"
        target="_blank"
      >
        {{ image.user.username }}
      </a>
      {{ $t('On') }}
      <a
        class="user-link__text"
        href="https://unsplash.com/?utm_source=admin&utm_medium=referral"
        target="_blank"
      >
        Unsplash
      </a>
    </div>
  </button>
</template>

<script>
// TODO: check admin namechange to manager for Unsplash app:
export default {
  props: {
    image: {
      type: Object,
      required: false,
      default: () => {},
    },
    selectedImageId: {
      type: String,
      required: false,
      default: '',
    },
    isLoadingImages: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  emits: ['click', 'dblclick'],
  data() {
    return {
      isLoading: true,
    }
  },
  computed: {
    isSelected() {
      return this.image.id === this.selectedImageId
    },
    computedStyle() {
      return {
        backgroundColor: this.image.color,
        aspectRatio: `${this.image.width}/${this.image.height}`,
      }
    },
  },
  methods: {
    click() {
      this.$emit('click')
    },
    dblclick() {
      this.$emit('dblclick')
    },
    setPicture() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  position: relative;
  background: none;
  border-radius: $spacing-3xs;
  border: $spacing-5xs solid $color-canvas;
  text-align: left;
  width: 100%;

  &--selected {
    border-color: $color-navigation;
  }

  &:hover {
    .user-link {
      visibility: visible;
    }
  }
}

.checkmark {
  position: absolute;
  top: $spacing-3xs;
  left: $spacing-3xs;
  display: flex;
  justify-content: center;
  align-items: center;
  width: $spacing-m;
  height: $spacing-m;
  border-radius: 50%;
  border: 2px solid $color-canvas;
  background: $color-navigation;
  box-shadow: 0 0 8px #0088ff88;
  z-index: 1;

  &__image {
    width: $spacing-3xs;
    height: $spacing-3xs;
  }
}

.skeleton,
.image {
  display: flex;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: $spacing-4xs;
  cursor: pointer;
  overflow: hidden;
}

.image--loading {
  display: none;
}

.user-link {
  visibility: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: $spacing-5xs $spacing-4xs;
  background: #00000088;
  border-radius: 0 0 $spacing-4xs $spacing-4xs;
  backdrop-filter: blur(2px);
  color: $color-canvas;
  font-weight: 400;
  font-size: $font-size-s;

  &__text {
    text-decoration: underline;
    color: inherit;
    font-weight: inherit;
  }
}
</style>
